// extracted by mini-css-extract-plugin
export default {"formGroup":"Select_formGroup__c2jfc","mandatory":"Select_mandatory__uYzHq"};